import { z } from 'zod';

// If you update this Kind
// You have to update `oms_return_status` of i18n
export type ReturnStatusKind =
  | { kind: 'Waiting' }
  | { kind: 'New' }
  | { kind: 'PayoutOnHold' }
  | { kind: 'Open' }
  | { kind: 'Pending' }
  | { kind: 'OnHold' }
  | { kind: 'AgentAllowReturn' }
  | { kind: 'LabelGenerated' }
  | { kind: 'LabelGeneratedFailed' }
  | { kind: 'NotShipped' }
  | { kind: 'ProviderReceived' }
  | { kind: 'DeliveredToSeller' }
  | { kind: 'PendingSellerReview' }
  | { kind: 'FailedSellerReturnConfirmity' }
  | { kind: 'FailedReturnPostalLitigation' }
  | { kind: 'FailReturnDecision' }
  | { kind: 'RelistOutOfSLA' }
  | { kind: 'Disagree' }
  | { kind: 'Agree' }
  | { kind: 'Solved' }
  | { kind: 'FollowUp' }
  | { kind: 'PayoutCancel' }
  | { kind: 'PayoutRelease' }
  | { kind: 'BuyerRefundRequest' }
  | { kind: 'Closed' }
  | { kind: 'InProgress' }
  | { kind: 'Completed' }
  | { kind: 'PayoutDoneAsOnHold' }
  | { kind: 'PayoutDoneAsRelease' }
  | { kind: 'PayoutDoneAsCancel' }
  | { kind: 'AgentNotAllowReturn' }
  | { kind: 'AllowReturn' }
  | { kind: 'FailZendeskMegedAndClosed' }
  | { kind: 'Both' }
  | { kind: 'Delivered' }
  | { kind: 'Lost' }
  | { kind: 'GoingBackToSender' }
  | { kind: 'DeliveredBackToSender' }
  | { kind: 'WarehouseInBound' }
  | { kind: 'AuthNoNeed' }
  | { kind: 'AuthAccepted' }
  | { kind: 'AuthRejected' }
  | { kind: 'QcAccepted' }
  | { kind: 'QcRejected' }
  | { kind: 'ReturnAccepted' }
  | { kind: 'ReturnRejected' }
  | { kind: 'SellerPayoutCancel' }
  | { kind: 'SellerPayoutRelease' }
  | { kind: 'PayoutForceRelease' }
  | { kind: 'SellerPayoutSuccess' }
  | { kind: 'SellerPayoutFailed' }
  | { kind: 'BuyerRefundSuccess' }
  | { kind: 'BuyerRefundFailed' }
  | { kind: 'BuyerRefund' }
  | { kind: 'NoBuyerRefund' }
  | { kind: 'SellerRelist' }
  | { kind: 'SellerRelisted' }
  | { kind: 'BuyerRelist' }
  | { kind: 'BuyerRelisted' }
  | { kind: 'VdcRelist' }
  | { kind: 'VdcRelisted' }
  | { kind: 'NoRelist' }
  | { kind: 'SellerReturn' }
  | { kind: 'CounterFeit' }
  | { kind: 'Loss' }
  | { kind: 'LostInStock' }
  | { kind: 'AgentAllowInstantRefund' }
  | { kind: 'BuyerInstantRefund' }
  | { kind: 'FailSellerPayoutExecution' }
  | { kind: 'TimeoutNoWHReturnDecision' }
  | { kind: 'FailedNoReturnDelivered' }
  | { kind: 'FailedReturnToSenderNotDelivered' }
  | { kind: 'FailedNoZendeskAssignee' }
  | { kind: 'SellerReturnConformityReported' }
  | { kind: 'SellerReturnConformityRefundBuyer' }
  | { kind: 'FailedSellerReturnConformityNoDecision' }
  | { kind: 'SellerReturnConformityPaySeller' }
  | { kind: 'FailedSellerPayoutClosed' }
  | { kind: 'Invalid'; value: string };

export const ReturnStatusDataSchema = z.object({
  status: z.any().transform(toReturnStatusKind).nullish(),
  operator: z.string().nullish(),
  updatedAt: z.string(),
});
export type ReturnStatusData = z.infer<typeof ReturnStatusDataSchema>;

export const ReturnStatusSchema = z.object({
  id: z.number(),
  returnId: z.number(),
  zendeskId: z.string(),
  status: z.any().transform(toReturnStatusKind).nullish(),
  subStatus: z.any().transform(toReturnStatusKind).nullish(),
  data: ReturnStatusDataSchema.array(),
});
export type ReturnStatus = z.infer<typeof ReturnStatusSchema>;

export function toReturnStatusKind(s: unknown): ReturnStatusKind {
  if (typeof s === 'string') {
    switch (s.toUpperCase()) {
      case 'WAITING':
        return { kind: 'Waiting' };
      case 'NEW':
        return { kind: 'New' };
      case 'PAYOUT_ONHOLD':
        return { kind: 'PayoutOnHold' };
      case 'OPEN':
        return { kind: 'Open' };
      case 'PENDING':
        return { kind: 'Pending' };
      case 'ONHOLD':
        return { kind: 'OnHold' };
      case 'AGENT_ALLOW_RETURN':
        return { kind: 'AgentAllowReturn' };
      case 'LABEL_GENERATED':
        return { kind: 'LabelGenerated' };
      case 'LABEL_GENERATION_FAILED':
        return { kind: 'LabelGeneratedFailed' };
      case 'NOT_SHIPPED':
        return { kind: 'NotShipped' };
      case 'PROVIDER_RECEIVED':
        return { kind: 'ProviderReceived' };
      case 'DELIVERED_TO_SELLER':
        return { kind: 'DeliveredToSeller' };
      case 'PENDING_SELLER_REVIEW':
        return { kind: 'PendingSellerReview' };
      case 'FAILED_SELLER_RETURN_CONFORMITY':
        return { kind: 'FailedSellerReturnConfirmity' };
      case 'FAILED_RETURN_PL':
        return { kind: 'FailedReturnPostalLitigation' };
      case 'FAIL_RETURN_DECISION':
        return { kind: 'FailReturnDecision' };
      case 'RELIST_OUT_OF_SLA':
        return { kind: 'RelistOutOfSLA' };
      case 'DISAGREE':
        return { kind: 'Disagree' };
      case 'AGREE':
        return { kind: 'Agree' };
      case 'SOLVED':
        return { kind: 'Solved' };
      case 'FOLLOWUP':
        return { kind: 'FollowUp' };
      case 'PAYOUT_CANCEL':
        return { kind: 'PayoutCancel' };
      case 'PAYOUT_RELEASE':
        return { kind: 'PayoutRelease' };
      case 'BUYER_REFUND_REQUEST':
        return { kind: 'BuyerRefundRequest' };
      case 'CLOSED':
        return { kind: 'Closed' };
      case 'IN_PROGRESS':
        return { kind: 'InProgress' };
      case 'COMPLETED':
        return { kind: 'Completed' };
      case 'PAYOUT_DONE_AS_ON_HOLD':
      case 'PAYOUT_DONE_AS_ONHOLD':
        return { kind: 'PayoutDoneAsOnHold' };
      case 'PAYOUT_DONE_AS_RELEASE':
        return { kind: 'PayoutDoneAsRelease' };
      case 'PAYOUT_DONE_AS_CANCEL':
        return { kind: 'PayoutDoneAsCancel' };
      case 'AGENT_NOT_ALLOW_RETURN':
        return { kind: 'AgentNotAllowReturn' };
      case 'ALLOW_RETURN':
        return { kind: 'AllowReturn' };
      case 'FAIL_ZENDESK_MERGED_AND_CLOSED':
        return { kind: 'FailZendeskMegedAndClosed' };
      case 'BOTH':
        return { kind: 'Both' };
      case 'DELIVERED':
        return { kind: 'Delivered' };
      case 'LOST':
        return { kind: 'Lost' };
      case 'GOING_BACK_TO_SENDER':
        return { kind: 'GoingBackToSender' };
      case 'DELIVERED_BACK_TO_SENDER':
        return { kind: 'DeliveredBackToSender' };
      case 'INBOUND':
        return { kind: 'WarehouseInBound' };
      case 'AUTH_NO_NEED':
        return { kind: 'AuthNoNeed' };
      case 'AUTH_ACCEPTED':
        return { kind: 'AuthAccepted' };
      case 'AUTH_REJECTED':
        return { kind: 'AuthRejected' };
      case 'QC_ACCEPTED':
        return { kind: 'QcAccepted' };
      case 'QC_REJECTED':
        return { kind: 'QcRejected' };
      case 'RETURN_ACCEPTED':
        return { kind: 'ReturnAccepted' };
      case 'RETURN_REJECTED':
        return { kind: 'ReturnRejected' };
      case 'SELLER_PAYOUT_CANCEL':
        return { kind: 'SellerPayoutCancel' };
      case 'SELLER_PAYOUT_RELEASE':
        return { kind: 'SellerPayoutRelease' };
      case 'PAYOUT_FORCE_RELEASE':
        return { kind: 'PayoutForceRelease' };
      case 'SELLER_PAYOUT_SUCCESS':
        return { kind: 'SellerPayoutSuccess' };
      case 'SELLER_PAYOUT_FAILED':
        return { kind: 'SellerPayoutFailed' };
      case 'BUYER_REFUND_SUCCESS':
        return { kind: 'BuyerRefundSuccess' };
      case 'BUYER_REFUND_FAILED':
        return { kind: 'BuyerRefundFailed' };
      case 'BUYER_REFUND':
        return { kind: 'BuyerRefund' };
      case 'NO_BUYER_REFUND':
        return { kind: 'NoBuyerRefund' };
      case 'SELLER_RELIST':
        return { kind: 'SellerRelist' };
      case 'SELLER_RELISTED':
        return { kind: 'SellerRelisted' };
      case 'BUYER_RELIST':
        return { kind: 'BuyerRelist' };
      case 'BUYER_RELISTED':
        return { kind: 'BuyerRelisted' };
      case 'VDC_RELIST':
        return { kind: 'VdcRelist' };
      case 'VDC_RELISTED':
        return { kind: 'VdcRelisted' };
      case 'NO_RELIST':
        return { kind: 'NoRelist' };
      case 'SELLER_RETURN':
        return { kind: 'SellerReturn' };
      case 'COUNTERFEIT':
        return { kind: 'CounterFeit' };
      case 'LOSS':
        return { kind: 'Loss' };
      case 'LOST_IN_STOCK':
        return { kind: 'LostInStock' };
      case 'AGENT_ALLOW_INSTANT_REFUND':
        return { kind: 'AgentAllowInstantRefund' };
      case 'BUYER_INSTANT_REFUND':
        return { kind: 'BuyerInstantRefund' };
      case 'FAIL_SELLER_PAYOUT_EXECUTION':
        return { kind: 'FailSellerPayoutExecution' };
      case 'FAILED_TIMEOUT_NO_WH_RETURN_DECISION':
          return { kind: 'TimeoutNoWHReturnDecision' };
      case 'FAILED_NO_RETURN_DELIVERED':
          return { kind: 'FailedNoReturnDelivered' };
      case 'FAIL_RETURN_TO_SENDER_NOT_DELIVERED':
          return { kind: 'FailedReturnToSenderNotDelivered' };
      case 'FAILED_NO_ZENDESK_ASSIGNEE':
          return { kind: 'FailedNoZendeskAssignee' };
      case 'SELLER_RETURN_CONFORMITY_REPORTED':
          return { kind: 'SellerReturnConformityReported' };
      case 'SELLER_RETURN_CONFORMITY_REFUND_BUYER':
          return { kind: 'SellerReturnConformityRefundBuyer' };
      case 'FAILED_SELLER_RETURN_CONFORMITY_NO_DECISION':
          return { kind: 'FailedSellerReturnConformityNoDecision' };
      case 'SELLER_RETURN_CONFORMITY_PAY_SELLER':
          return { kind: 'SellerReturnConformityPaySeller' };
      case 'FAILED_SELLER_PAYOUT_CLOSED':
          return { kind: 'FailedSellerPayoutClosed' };
    }
  }
  return { kind: 'Invalid', value: String(s) };
}

export enum LitigationType {
  RETURN = 'RETURN',
  POSTAL_SELLER = 'POSTAL_SELLER',
  POSTAL_BUYER = 'POSTAL_BUYER',
  REPLACEMENT_ZENDESK_TICKET = 'REPLACEMENT_ZENDESK_TICKET',
}
